import axios from 'axios'

export default {
  namespaced: true,

  state: {
    id: null // campaign id
  },

  getters: {},

  actions: {
    async update ({ commit, state }, id) {
      commit('setId', id)
    }
  },

  mutations: {
    setId (state, id) {
      state.id = id
    }
  }
}
